// Shared layout tokens for the Booking V2 flow.
//
// The desktop summary rail is unified at 360px across all three steps
// (seats / concessions / checkout) — see MVK-2396. Keep this as the single
// source of truth instead of hard-coding the track width per page.
//
// Tailwind's JIT needs the arbitrary value as a literal class string, so we
// export the full `grid-cols-[…]` class (not just the px number). This file is
// covered by the tailwind content globs (`./src/**/*.{ts,tsx}`), so the class is
// picked up wherever it's composed.
export const SUMMARY_RAIL_COLS = 'lg:grid-cols-[minmax(0,1fr)_360px]';
